export default __webpack_public_path__ + "static/night_ctaModule_table_tablet-55a3d8bcc72d4bf8d3de10dd47c2a2fd.webp";